import React from 'react';
import s from './AutoCheck.scss';

const AutoCheck = ({
  isAutoSuggestActive,
  handleAutoCheckClick,
  positionClass,
}) => (
  <div className={`${s.autoCheck} ${positionClass ? s.bottom : ''}`}>
    <label htmlFor="autoCheckInput">
      Auto Check
      <input
        id="autoCheckInput"
        type="checkbox"
        checked={isAutoSuggestActive}
        onChange={handleAutoCheckClick}
      />
      <i className={s.tickIcon} />
    </label>
    <div className={s.toolTipInfo}>
      <i className={s.info} />
      <div className={s.toolTipContent}>
        View possible candidates for empty cells in real time. Filled numbers
        update the grid dynamically to refine your choices.
      </div>
    </div>
  </div>
);

export default AutoCheck;
